/**
 * @description fetches the options for the special access dropdown used by the filter form
 */

import { useQuery } from '@tanstack/react-query'

import processOrderedDropdownOptions from '../utils/processOrderedDropdownOptions';
import fetchDropdownOptions from '../utils/fetchDropdownOptions';

const fetchSpecialAccesses = fetchDropdownOptions(
  'personnel.specialAccess.type',
  'special access level'
);

const useSpecialAccessOptions = () => {
  const { data, isError, isLoading } = useQuery({
    queryKey: ['useSpecialAccessOptions'],
    queryFn: fetchSpecialAccesses,
    select: processOrderedDropdownOptions,
    refetchOnWindowFocus: false,
    staleTime: Infinity
  });

  return {
    data,
    isError,
    isLoading
  };
};

export default useSpecialAccessOptions;
